// import dayjs from 'dayjs';
// import utc from 'dayjs/plugin/utc'
// import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
// import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
// import timezone from 'dayjs/plugin/timezone'
import moment from 'moment-timezone'
import store from '../../reducers'
// dayjs.extend(utc)
// dayjs.extend(timezone)
// dayjs.extend(isSameOrBefore)
// dayjs.extend(isSameOrAfter)

// module.exports = (time)=>{
//     let organization = store.getState().organization
//     let _dayjs = dayjs(time)
//     if(organization.timezone){
    //         _dayjs = _dayjs.tz(organization.timezone)
    //     }
    //     return _dayjs
    // }
    
const dayjs = (datetime)=>{
    let organization = store.getState().organization
    if(organization.timezone){
        return moment(datetime).tz(organization.timezone);
    }

    return moment(datetime);
}

export default dayjs


// WEBPACK FOOTER //
// ./lib/helpers/dayjs.js